




import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'GGroupEditItemCell',
  computed: {},
  methods: {},
})
export default class GGroupEditItemCell extends Vue {
  mounted() {}
}
